import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router'
import Header from './Header'
import Sidebar from './Sidebar'
import { use } from '../Helpers'
import { call } from '../Methods'
import CommandForm from './CommandForm'

function Layout () {
  const token = use.token()
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams, setSearchParams] = useSearchParams();
  const [showCommandFormModal, setShowCommandFormModal] = useState()
  const [commandName, setCommandName] = useState()
  
  const getSettings = async () => {
    const settings = await call.forLoggedUser.setting.getSettings({})
    if (settings.success && settings.data.length > 0) {
      let _settings = {}
      settings.data.forEach(s => {
        _settings[s.name] = { ...s }
        delete _settings[s.name].name
      })
    }
  }

  useEffect(() => {
    const requestType = searchParams.get("requestType");
    const commandName = searchParams.get("commandName");
    if (requestType=='command' && commandName) {
      setCommandName(commandName);
      setShowCommandFormModal(true);
    } else {
      setShowCommandFormModal(false);
    }
  }, [searchParams]);

  useEffect(() => {
    if (!token) {
      navigate('/login', { replace: true })
    } else {
      getSettings()
    }
  }, [])

  if (token)
    return (
      <div className='layout'>
        {showCommandFormModal && <CommandForm name={commandName} parameters={JSON.parse(searchParams.get("parameters"))} warning={searchParams.get("warning")} onSubmit={()=>console.log('submitted')}/>}
        <Header />
        <Sidebar />
        <main>
          <Outlet />
        </main>
        <footer></footer>
      </div>
    )
}

export default Layout
